<template>
  <div class="mini-tab-content">
    <div
      v-if="loadingVitals"
      class="interc-loading"
    >
      <b-spinner
        small
        variant="primary"
      />
      <span>Carregando...</span>
    </div>
    <template v-else>
      <div class="interc-toolbar">
        <span class="interc-toolbar__title">
          <feather-icon
            icon="ActivityIcon"
            size="13"
            class="mr-25 text-primary"
          />
          {{ vitalSigns.length ? vitalSigns.length + ' avaliação(ões)' : 'Nenhuma avaliação' }}
        </span>
        <button
          class="btn btn-sm btn-primary"
          @click="showVitalModal = true"
        >
          <feather-icon
            icon="PlusIcon"
            size="13"
            class="mr-25"
          />
          Nova Avaliação
        </button>
      </div>

      <div
        v-if="!vitalSigns.length"
        class="interc-empty"
      >
        <feather-icon
          icon="HeartIcon"
          size="26"
        />
        <p>Nenhuma avaliação registrada.</p>
      </div>

      <div
        v-if="vitalSigns.length"
        class="vs-history"
      >
        <div class="table-responsive">
          <table class="table table-sm vs-history__table mb-0">
            <thead>
              <tr>
                <th>Data/Hora</th>
                <th>FC</th>
                <th>FR</th>
                <th>SpO₂</th>
                <th>Temp</th>
                <th>PA</th>
                <th>Glasgow</th>
                <th>Obs</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="vs in vitalSigns"
                :key="vs.id"
              >
                <td class="text-nowrap">
                  {{ vs.created_at | formatDate }}
                </td>
                <td>{{ vs.fc || '—' }}</td>
                <td>{{ vs.fr || '—' }}</td>
                <td>{{ vs.saturation ? vs.saturation + '%' : '—' }}</td>
                <td>{{ vs.temperature ? vs.temperature + '°C' : '—' }}</td>
                <td class="text-nowrap">
                  <span v-if="vs.pa_systolic">{{ vs.pa_systolic }}/{{ vs.pa_diastolic }}</span>
                  <span v-else>—</span>
                </td>
                <td>{{ vs.glasgow || '—' }}</td>
                <td class="vs-obs-cell">
                  {{ vs.other_observations || '—' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>

    <b-modal
      v-model="showVitalModal"
      title="Nova Avaliação de Sinais Vitais"
      size="lg"
      centered
      no-close-on-backdrop
      @hidden="newVital = emptyVital()"
    >
      <div class="row">
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">Freq. Cardíaca (bpm)</label>
            <input
              v-model="newVital.fc"
              class="form-control"
              type="number"
              placeholder="—"
            >
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">Freq. Respiratória (rpm)</label>
            <input
              v-model="newVital.fr"
              class="form-control"
              type="number"
              placeholder="—"
            >
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">SpO₂ (%)</label>
            <input
              v-model="newVital.saturation"
              class="form-control"
              type="number"
              placeholder="—"
            >
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">Temperatura (°C)</label>
            <input
              v-model="newVital.temperature"
              class="form-control"
              type="number"
              step="0.1"
              placeholder="—"
            >
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">PA Sistólica (mmHg)</label>
            <input
              v-model="newVital.pa_systolic"
              class="form-control"
              type="number"
              placeholder="—"
            >
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">PA Diastólica (mmHg)</label>
            <input
              v-model="newVital.pa_diastolic"
              class="form-control"
              type="number"
              placeholder="—"
            >
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">Glasgow</label>
            <input
              v-model="newVital.glasgow"
              class="form-control"
              type="number"
              min="3"
              max="15"
              placeholder="—"
            >
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">Glicemia (mg/dL)</label>
            <input
              v-model="newVital.blood_glucose"
              class="form-control"
              type="number"
              placeholder="—"
            >
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">Peso (kg)</label>
            <input
              v-model="newVital.weight"
              class="form-control"
              type="number"
              step="0.1"
              placeholder="—"
            >
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">Altura (m)</label>
            <input
              v-model="newVital.height"
              class="form-control"
              type="number"
              step="0.01"
              placeholder="—"
            >
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">Nível de Consciência</label>
            <select
              v-model="newVital.neurological_status"
              class="form-control"
            >
              <option value="">
                —
              </option>
              <option>Alerta</option>
              <option>Voz</option>
              <option>Dor</option>
              <option>Inconsciente</option>
            </select>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">Via Aérea</label>
            <select
              v-model="newVital.airway"
              class="form-control"
            >
              <option value="">
                —
              </option>
              <option>Pérvea</option>
              <option>Obstruída</option>
              <option>IOT</option>
              <option>MLS</option>
            </select>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">Ventilação</label>
            <select
              v-model="newVital.mechanical_ventilation"
              class="form-control"
            >
              <option value="">
                —
              </option>
              <option>Espontânea</option>
              <option>Assistida</option>
              <option>Controlada</option>
            </select>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label class="form-label">Oxigenoterapia</label>
            <select
              v-model="newVital.support_o2"
              class="form-control"
            >
              <option value="">
                —
              </option>
              <option>Sem O₂</option>
              <option>Cateter nasal</option>
              <option>Máscara simples</option>
              <option>Máscara reservatório</option>
              <option>VMI</option>
            </select>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="form-group">
            <label class="form-label">Observações</label>
            <textarea
              v-model="newVital.other_observations"
              class="form-control"
              rows="2"
              placeholder="—"
            />
          </div>
        </div>
      </div>

      <template #modal-footer>
        <button
          class="btn btn-sm btn-outline-secondary mr-1"
          @click="showVitalModal = false"
        >
          Cancelar
        </button>
        <button
          class="btn btn-sm btn-success"
          :disabled="savingVital"
          @click="saveVital"
        >
          <b-spinner
            v-if="savingVital"
            small
            class="mr-25"
          />
          <feather-icon
            v-else
            icon="SaveIcon"
            size="13"
            class="mr-25"
          />
          Registrar Avaliação
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import involvedPanelMixin from './involvedPanelMixin'

export default {
  name: 'VitalSignsPanel',
  mixins: [involvedPanelMixin],
  data() {
    return {
      vitalSigns: [],
      loadingVitals: false,
      showVitalModal: false,
      savingVital: false,
      newVital: this.emptyVital(),
    }
  },
  mounted() {
    this.fetchVitalSigns()
  },
  methods: {
    emptyVital() {
      return {
        fc: '',
        fr: '',
        saturation: '',
        temperature: '',
        pa_systolic: '',
        pa_diastolic: '',
        glasgow: '',
        blood_glucose: '',
        weight: '',
        height: '',
        neurological_status: '',
        airway: '',
        mechanical_ventilation: '',
        support_o2: '',
        other_observations: '',
      }
    },
    async fetchVitalSigns() {
      this.loadingVitals = true
      try {
        const res = await this.$http.get(`${this.$store.state.api}vital_signs_involveds`, {
          params: { involved_id: this.involvedId, occurrence_id: this.occurrenceId },
        })
        this.vitalSigns = res.data.data || res.data || []
      } catch (e) {
        this.vitalSigns = []
      } finally {
        this.loadingVitals = false
      }
    },
    async saveVital() {
      this.savingVital = true
      try {
        const payload = { ...this.newVital, involved_id: this.involvedId, occurrence_id: this.occurrenceId }
        const res = await this.$http.post(`${this.$store.state.api}vital_signs_involveds`, payload)
        const saved = res.data.data || res.data
        this.vitalSigns.push(saved)
        this.newVital = this.emptyVital()
        this.showVitalModal = false
        this.$message('Avaliação registrada', 'Sinais vitais salvos com sucesso.', 'success')
      } catch (e) {
        this.$message('Erro', 'Erro ao registrar avaliação.', 'error')
      } finally {
        this.savingVital = false
      }
    },
  },
}
</script>
